import React, {useState, useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {AddProductModalProps, Discount} from '../types';
import Modal from "../../../ui-components/Modal";
import Button from "../../../ui-components/Button";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";
import SelectProduct from "@components/SelectProduct";
import {ProductsSchema} from "@types";
import Input from "../../../ui-components/Input";
import {PDFProductSplitQuantitiesSchema} from "../../worksites/detail/types";
import {SurveyProductItemSchema} from "../../commons";
import {ProductImage} from "../quotation-product/product-image";
import {TechnicalSheet} from "../quotation-product/technical-sheet";
import {computeTotals} from "../quotation-draft/lib/utilities";
export const AddProductModal = ({
  surveys,
  onConfirm,
  onClose
}: AddProductModalProps) => {

  const [productOption, setProductOption] = useState({value: "", label: ""});
  const [product, setProduct] = useState<ProductsSchema>();
  const [surveyProductItem, setSurveyProductItem] = useState<SurveyProductItemSchema>();
  const [quantity, setQuantity] = useState<number>();
const [totals, setTotals] = useState({original: 0, discounted: 0});
  const apiRequest = useCountryAxiosInstance();

  useEffect(() => {
    const fetchProduct = async () => {
      const response = await apiRequest.get(`/products/all?id=${productOption.value}`);
      setProduct(response[0]);
    }
    if (productOption.value)
      fetchProduct();
    else
      setProduct(undefined);
  }, [productOption]);

  useEffect(() => {
    if (product && quantity) {
      const surveyProductItem = {
        product: product,
        quantity: quantity * product.min_qty,
        isKcc: false, // @TODO: HOW CAN I SET CORRECT VALUE???
        splitQuantities: {
          [surveys[0].id]: {
            recursive_questions: {},
            main: quantity * product.min_qty * product.prezzo,
            survey_name: surveys[0].name
          } as PDFProductSplitQuantitiesSchema
        }
      } as SurveyProductItemSchema;
      setSurveyProductItem(surveyProductItem);
      setTotals(computeTotals(quantity*product.min_qty, product.min_qty, product.prezzo, {percentage: 0, value: 0} as Discount, null));
    }
  }, [product, quantity]);

  return <Modal
    title="Add Product"
    onExit={onClose}
    overflowCls={"min-h-250"}
    // large={!!surveyProductItem}
  >
    <div className={"justify-center m-4 grid grid-cols-1 gap-y-5"}>
      <SelectProduct
        value={productOption}
        onChange={(prodOption:{value:string,label:string,secondaryLabel:string})=> {
          setProductOption({
            value: prodOption.value,
            label: prodOption.secondaryLabel,
          })
        }}
        location="ServiceConfiguratorCalculation"
        noZeroPrice={true}
      />
      {product && (
        <div  className={"grid grid-cols-1"}>
          <Input
            label="Quantity"
            type="number"
            value={quantity}
            onChange={e=>{setQuantity(Number(e.target.value))}}
          />
          {surveyProductItem &&(
            <div className={"grid grid-cols-2"}>
              <TechnicalSheet
                productInfo={surveyProductItem}
                slim={false}
                totals={totals}
              />
              <ProductImage
                link_image={product.link_image}
                slim={false}
              />
            </div>
          )}
        </div>
      )}
      <Button
        full
        onClick={() => {
          if (surveyProductItem)
            onConfirm(surveyProductItem);
          onClose();
        }}
        disabled={!surveyProductItem}
      >
        <FormattedMessage id="add"/>
      </Button>
    </div>


  </Modal>
}